
/* ==========================================
   PACK SIZE - CLEAN VERSION
   NO CUSTOM LOADER
   NO SHOPFLO IFRAME SYNC
   NO JAVASCRIPT DISCOUNTS
========================================== */

function formatMoney(cents) {
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    maximumFractionDigits: 0
  }).format(cents / 100);
}

window.PackSize = window.PackSize || {};

/* ==========================================
   HELPERS
========================================== */

window.PackSize.getCartRoot = function () {
  return window.Shopify?.routes?.root || '/';
};

window.PackSize.getValidScope = function (scopeElement) {
  return scopeElement &&
    typeof scopeElement.querySelector === 'function'
    ? scopeElement
    : document;
};

window.PackSize.getVariantsFromScope = function (scopeElement) {
  const scope = this.getValidScope(scopeElement);

  let variantsList = [];

  const jsonScript =
    scope.querySelector('.pack-size-variants-json') ||
    document.querySelector('.pack-size-variants-json');

  if (jsonScript) {
    try {
      variantsList = JSON.parse(jsonScript.textContent);
    } catch (error) {
      console.error(
        'Pack-size variants could not be read:',
        error
      );
    }
  }

  return variantsList?.length
    ? variantsList
    : (window.variants || []);
};

window.PackSize.getOffer = function (index) {
  return window.packOffers?.find(
    offer => Number(offer.cardIndex) === Number(index)
  );
};

/* ==========================================
   RENDER BADGES
========================================== */

window.PackSize.renderBadge = function (offer) {
  return offer?.badge
    ? `<div class="pack-size-badge">${offer.badge}</div>`
    : '';
};

window.PackSize.renderPercentageBadge = function (offer) {
  return offer?.percentageOffBadge
    ? `<span class="pack-size-percentage-badge">
        ${offer.percentageOffBadge}
      </span>`
    : '';
};

/* ==========================================
   PER TUBE PRICE
========================================== */

window.PackSize.renderPerTube = function (variant) {
  if (!variant.metafields?.custom?.quantity) {
    return '';
  }

  return `<p class="pack-size-per-tube">
    ${formatMoney(
      variant.price / variant.metafields.custom.quantity
    )} per tube
  </p>`;
};

/* ==========================================
   MESSAGES
========================================== */

window.PackSize.renderMessage = function (offer) {
  if (!offer?.message || offer.product?.image) {
    return '';
  }

  return `<p class="pack-size-gift-text">
    ${offer.message}
  </p>`;
};

window.PackSize.renderPackSizeMessage = function (offer) {
  return offer?.packSizeMessage
    ? `<p class="pack-size-message">
        ${offer.packSizeMessage}
      </p>`
    : '';
};

/* ==========================================
   VARIANT PRICE DISPLAY
========================================== */

window.PackSize.renderVariantPrice = function (variant) {
  const comparePrice =
    variant.compare_at_price > variant.price
      ? `<div class="pack-size-compare-price">
          ${formatMoney(variant.compare_at_price)}
        </div>`
      : '';

  return `<div class="pack-size-price">
    <div class="pack-size-sale-price">
      ${formatMoney(variant.price)}
    </div>
    ${comparePrice}
  </div>`;
};

/* ==========================================
   RENDER GIFT OFFER

   Prices here are only UI display.
   No discount is applied by JavaScript.
========================================== */

window.PackSize.renderOffer = function (offer) {
  if (!offer?.product?.image) {
    return '';
  }

  const isChecked = offer.active === true;

  const checkbox = offer.showCheckbox
    ? `<div
        class="pack-size-offer-checkbox ${
          isChecked ? 'active' : ''
        }"
        data-offer-index="${offer.cardIndex}">
      </div>`
    : '';

  const price =
    offer.offerPrice || offer.comparePrice
      ? `<div class="pack-size-offer-prices">
          <div class="pack-size-offer-price">
            ${
              offer.offerPrice
                ? `₹${Number(offer.offerPrice).toLocaleString('en-IN')}`
                : 'FREE'
            }
          </div>

          ${
            offer.comparePrice
              ? `<div class="pack-size-offer-compare">
                  ₹${Number(offer.comparePrice).toLocaleString('en-IN')}
                </div>`
              : ''
          }
        </div>`
      : '';

  return `<div
    class="pack-size-offer"
    data-card-index="${offer.cardIndex}">

    ${checkbox}

    <img
      class="pack-size-offer-image"
      src="${offer.product.image}"
      alt=""
    >

    <div class="pack-size-offer-content">
      <div class="pack-size-offer-title">
        ${offer.message || offer.product.title}
      </div>
    </div>

    ${price}
  </div>`;
};

/* ==========================================
   SYNC SELECTED GIFT VARIANT
========================================== */

window.PackSize.syncOfferVariant = function (
  selectedVariant,
  scopeElement
) {
  const scope = this.getValidScope(scopeElement);

  const offerInput =
    scope.querySelector('#offer_variant_id') ||
    document.querySelector('#offer_variant_id');

  if (!offerInput) return;

  const allVariants = this.getVariantsFromScope(scope);

  if (!allVariants?.length) return;

  const selectedColor = selectedVariant.option1;

  const hasColourOption =
    selectedColor &&
    !selectedColor.toLowerCase().includes('pack');

  const filteredVariants = hasColourOption
    ? allVariants.filter(
        variant => variant?.option1 === selectedColor
      )
    : allVariants;

  const variantIndex = filteredVariants.findIndex(
    variant =>
      Number(variant?.id) === Number(selectedVariant.id)
  );

  const offer =
    variantIndex >= 0
      ? this.getOffer(variantIndex)
      : null;

  offerInput.value =
    offer?.active === true && offer.product?.variantId
      ? offer.product.variantId
      : '';
};

/* ==========================================
   PACK CARD EVENTS
========================================== */

window.PackSize.bindPackCardEvents = function (scopeElement) {
  const scope = this.getValidScope(scopeElement);

  scope.querySelectorAll('.pack-size-card').forEach(card => {
    card.addEventListener('click', event => {
      if (event.target.closest('.pack-size-offer')) {
        return;
      }

      const parentForm =
        card.closest(
          'product-form, form[action*="/cart/add"]'
        ) || scope;

      const variantInput =
        parentForm.querySelector('[name="id"]');

      if (!variantInput) return;

      const allVariants =
        this.getVariantsFromScope(scope);

      const newVariant = allVariants.find(
        variant =>
          Number(variant?.id) ===
          Number(card.dataset.variantId)
      );

      if (!newVariant) return;

      variantInput.value = newVariant.id;

      variantInput.dispatchEvent(
        new Event('change', { bubbles: true })
      );

      this.renderPackCards(newVariant, scope);
    });
  });

  /* ======================================
     GIFT CHECKBOX
  ====================================== */

  scope.querySelectorAll('.pack-size-offer').forEach(
    offerBox => {
      offerBox.addEventListener('click', event => {
        event.stopPropagation();

        const offer = this.getOffer(
          offerBox.dataset.cardIndex
        );

        if (!offer?.showCheckbox) return;

        offer.active = offer.active !== true;

        const checkbox = offerBox.querySelector(
          '.pack-size-offer-checkbox'
        );

        const offerInput =
          scope.querySelector('#offer_variant_id') ||
          document.querySelector('#offer_variant_id');

        if (checkbox) {
          checkbox.classList.toggle(
            'active',
            offer.active
          );
        }

        if (offerInput) {
          offerInput.value =
            offer.active && offer.product?.variantId
              ? offer.product.variantId
              : '';
        }
      });
    }
  );
};

/* ==========================================
   RENDER PACK CARDS
========================================== */

window.PackSize.renderPackCards = function (
  selectedVariant,
  scopeElement
) {
  const scope = this.getValidScope(scopeElement);

  const container =
    scope.querySelector('.pack-size-cards');

  const allVariants =
    this.getVariantsFromScope(scope);

  if (!container || !allVariants?.length) {
    return;
  }

  const activeVariant =
    selectedVariant || allVariants[0];

  const selectedColor = activeVariant.option1;

  const hasColourOption =
    selectedColor &&
    !selectedColor.toLowerCase().includes('pack');

  const variantsToRender = hasColourOption
    ? allVariants.filter(
        variant => variant?.option1 === selectedColor
      )
    : allVariants;

  container.innerHTML = variantsToRender
    .map((variant, index) => {
      const isActive =
        Number(variant.id) ===
        Number(activeVariant.id);

      const offer = this.getOffer(index);

      return `<div
        class="pack-size-card ${
          isActive ? 'active' : ''
        }"
        data-variant-id="${variant.id}"
        data-offer-index="${index}">

        ${this.renderBadge(offer)}

        <div class="pack-size-card-top">
          <div class="pack-size-radio">
            ${isActive ? '<span></span>' : ''}
          </div>

          <div class="pack-size-content">
            <div class="pack-size-title-row">
              <h4>
                ${
                  variant.option2 ||
                  variant.option1 ||
                  variant.title
                }
              </h4>

              ${this.renderPercentageBadge(offer)}
            </div>

            ${this.renderPackSizeMessage(offer)}

            ${this.renderPerTube(variant)}

            ${this.renderMessage(offer)}
          </div>

          ${this.renderVariantPrice(variant)}
        </div>

        ${
          isActive
            ? this.renderOffer(offer)
            : ''
        }
      </div>`;
    })
    .join('');

  this.syncOfferVariant(activeVariant, scope);

  this.bindPackCardEvents(scope);
};

/* ==========================================
   READ SHOPIFY CART
========================================== */

window.PackSize.getCart = async function () {
  const response = await fetch(
    `${this.getCartRoot()}cart.js`,
    {
      cache: 'no-store',
      headers: {
        Accept: 'application/json'
      }
    }
  );

  if (!response.ok) {
    throw new Error(
      `Cart read failed: ${response.status}`
    );
  }

  return response.json();
};

/* ==========================================
   SHOPIFY THEME CART REFRESH

   No Shopflo iframe manipulation.
========================================== */

window.PackSize.refreshCartUI = async function () {
  const root = this.getCartRoot();

  try {
    const response = await fetch(
      `${root}?sections=cart-drawer,cart-icon-bubble`,
      {
        headers: {
          Accept: 'application/json'
        },
        cache: 'no-store'
      }
    );

    if (!response.ok) {
      throw new Error(
        `Cart refresh failed: ${response.status}`
      );
    }

    const sections = await response.json();

    const parser = new DOMParser();

    /* Update Shopify cart drawer */

    if (sections['cart-drawer']) {
      const drawerDoc = parser.parseFromString(
        sections['cart-drawer'],
        'text/html'
      );

      const currentDrawer =
        document.querySelector('cart-drawer');

      const freshDrawer =
        drawerDoc.querySelector('cart-drawer');

      const currentInner =
        currentDrawer?.querySelector('.drawer__inner');

      const freshInner =
        freshDrawer?.querySelector('.drawer__inner');

      if (currentInner && freshInner) {
        currentInner.innerHTML =
          freshInner.innerHTML;

        currentInner.classList.toggle(
          'is-empty',
          freshInner.classList.contains('is-empty')
        );
      }

      if (currentDrawer && freshDrawer) {
        currentDrawer.classList.toggle(
          'is-empty',
          freshDrawer.classList.contains('is-empty')
        );
      }
    }

    /* Update header cart icon */

    if (sections['cart-icon-bubble']) {
      const iconDoc = parser.parseFromString(
        sections['cart-icon-bubble'],
        'text/html'
      );

      const currentIcon =
        document.querySelector('#cart-icon-bubble');

      const freshIcon =
        iconDoc.querySelector('#cart-icon-bubble');

      if (currentIcon && freshIcon) {
        currentIcon.innerHTML =
          freshIcon.innerHTML;
      }
    }

    document.dispatchEvent(
      new CustomEvent('cart:updated', {
        bubbles: true
      })
    );

  } catch (error) {
    console.error(
      'PackSize cart UI refresh failed:',
      error
    );
  }
};

/* ==========================================
   LINKED GIFT CLEANUP

   Keeps Shopify cart data consistent.
   Does not refresh Shopflo iframe.
========================================== */

window.PackSize.syncBundleGifts = async function () {
  if (this.isSyncingBundleGifts) {
    this.bundleGiftSyncPending = true;
    return false;
  }

  this.isSyncingBundleGifts = true;

  try {
    const root = this.getCartRoot();

    const cart = await this.getCart();

    const parentQuantities = new Map();

    /* Find bundle parents */

    cart.items.forEach(item => {
      const properties = item.properties || {};

      if (
        properties._pack_size_bundle_role !== 'parent' ||
        !properties._pack_size_bundle_id
      ) {
        return;
      }

      const bundleId =
        String(properties._pack_size_bundle_id);

      const currentQuantity =
        parentQuantities.get(bundleId) || 0;

      parentQuantities.set(
        bundleId,
        currentQuantity + item.quantity
      );
    });

    const updates = {};

    /* Match gifts with parent products */

    cart.items.forEach(item => {
      const properties = item.properties || {};

      if (
        properties._pack_size_bundle_role !== 'gift' ||
        !properties._pack_size_bundle_id
      ) {
        return;
      }

      const bundleId =
        String(properties._pack_size_bundle_id);

      const parentQuantity =
        parentQuantities.get(bundleId) || 0;

      if (item.quantity !== parentQuantity) {
        updates[item.key] = parentQuantity;
      }
    });

    if (!Object.keys(updates).length) {
      return false;
    }

    /* Remove orphan gifts */

    const response = await fetch(
      `${root}cart/update.js`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({ updates })
      }
    );

    if (!response.ok) {
      throw new Error(
        `Gift cleanup failed: ${response.status}`
      );
    }

    await this.refreshCartUI();

    return true;

  } catch (error) {
    console.error(
      'PackSize bundle gift cleanup error:',
      error
    );

    return false;

  } finally {
    this.isSyncingBundleGifts = false;

    if (this.bundleGiftSyncPending) {
      this.bundleGiftSyncPending = false;
      this.queueBundleGiftSync();
    }
  }
};

/* ==========================================
   GIFT CLEANUP QUEUE
========================================== */

window.PackSize.queueBundleGiftSync = function () {
  window.clearTimeout(
    this.bundleGiftSyncTimer
  );

  this.bundleGiftSyncTimer = window.setTimeout(
    () => {
      this.syncBundleGifts();
    },
    150
  );
};

/* ==========================================
   INITIALIZE PACK SIZE
========================================== */

function bootPackSize(scopeInput) {
  const scope =
    scopeInput &&
    typeof scopeInput.querySelector === 'function'
      ? scopeInput
      : document;

  const wrapper =
    scope.querySelector('.pack-size-wrapper');

  if (
    !wrapper ||
    wrapper.dataset.packSizeReady === 'true'
  ) {
    return;
  }

  const allVariants =
    window.PackSize.getVariantsFromScope(scope);

  if (!allVariants?.length) return;

  wrapper.dataset.packSizeReady = 'true';

  const selectedInput =
    scope.querySelector('input[name="id"]');

  const initialVariant =
    allVariants.find(
      variant =>
        Number(variant?.id) ===
        Number(selectedInput?.value)
    ) || allVariants[0];

  window.PackSize.renderPackCards(
    initialVariant,
    scope
  );

  scope
    .querySelectorAll(
      '.variant-input, variant-radios input, variant-selects select, [data-option-position]'
    )
    .forEach(swatch => {
      swatch.addEventListener('change', () => {
        window.setTimeout(() => {
          const currentVariantId =
            scope.querySelector(
              'input[name="id"]'
            )?.value;

          const currentVariant = allVariants.find(
            variant =>
              Number(variant?.id) ===
              Number(currentVariantId)
          );

          if (currentVariant) {
            window.PackSize.renderPackCards(
              currentVariant,
              scope
            );
          }
        }, 50);
      });
    });
}

/* ==========================================
   ADD MAIN PRODUCT + OPTIONAL CAPE

   No JavaScript discount calculation.
   Shopify discounts handle the final price.
========================================== */

if (!window.PackSize.cartSubmitListenerBound) {
  document.addEventListener(
    'submit',
    function (event) {
      const form = event.target.closest(
        'form[action*="/cart/add"]'
      );

      if (!form) return;

      const productScope =
        form.closest(
          '.quick-add-modal, .shopify-section'
        ) || document;

      /* Ignore unrelated product forms */

      if (
        !productScope.querySelector(
          '.pack-size-wrapper'
        )
      ) {
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();

      const mainVariantId =
        form.querySelector('[name="id"]')?.value;

      if (!mainVariantId) return;

      const selectedPackCard =
        productScope.querySelector(
          '.pack-size-card.active'
        );

      const selectedOffer = selectedPackCard
        ? window.PackSize.getOffer(
            Number(
              selectedPackCard.dataset.offerIndex
            )
          )
        : null;

      /*
        Only add Cape if the gift
        checkbox is selected.
      */

      const offerVariantId =
        selectedOffer?.active === true &&
        selectedOffer?.product?.variantId
          ? String(
              selectedOffer.product.variantId
            )
          : '';

      const quantity = Math.max(
        1,
        parseInt(
          form.querySelector(
            '[name="quantity"]'
          )?.value,
          10
        ) || 1
      );

      /*
        Bundle ID is only for linking
        the main product with its Cape.
      */

      const bundleId = offerVariantId
        ? `pack_size_${Date.now()}_${Math.random()
            .toString(36)
            .slice(2, 10)}`
        : null;

      const mainProperties = {};

      /* Preserve existing form properties */

      new FormData(form).forEach((value, key) => {
        const match =
          key.match(/^properties\[(.+)\]$/);

        if (
          match &&
          typeof value === 'string'
        ) {
          mainProperties[match[1]] = value;
        }
      });

      if (bundleId) {
        mainProperties._pack_size_bundle_id =
          bundleId;

        mainProperties._pack_size_bundle_role =
          'parent';
      }

      /* Main product */

      const items = [
        {
          id: Number(mainVariantId),
          quantity,
          properties: mainProperties
        }
      ];

      /* Optional Cape product */

      if (offerVariantId) {
        items.push({
          id: Number(offerVariantId),
          quantity,
          properties: {
            _pack_size_bundle_id: bundleId,
            _pack_size_bundle_role: 'gift'
          }
        });
      }

      const submitButton =
        form.querySelector(
          '[type="submit"], [name="add"]'
        );

      if (submitButton) {
        submitButton.disabled = true;
      }

      fetch(
        `${window.PackSize.getCartRoot()}cart/add.js`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            items
          })
        }
      )
        .then(response => {
          if (!response.ok) {
            throw new Error(
              `Cart add request failed: ${response.status}`
            );
          }

          return response.json();
        })
        .then(async cartData => {
          document.dispatchEvent(
            new CustomEvent('cart:updated', {
              detail: {
                cart: cartData
              }
            })
          );

          await window.PackSize.refreshCartUI();
        })
        .catch(error => {
          console.error(
            'PackSize cart add error:',
            error
          );
        })
        .finally(() => {
          if (submitButton) {
            submitButton.disabled = false;
          }
        });
    },
    true
  );

  window.PackSize.cartSubmitListenerBound = true;
}

/* ==========================================
   DETECT SHOPIFY CART CHANGES
========================================== */

window.PackSize.isCartMutationUrl = function (
  requestUrl
) {
  try {
    const url = new URL(
      requestUrl,
      window.location.href
    );

    if (
      url.origin !== window.location.origin
    ) {
      return false;
    }

    return /\/cart\/(?:change|update|clear)(?:\.js)?$/.test(
      url.pathname
    );

  } catch (error) {
    return false;
  }
};

/* ==========================================
   FETCH CART OBSERVER

   Used only for bundle cleanup.
========================================== */

if (!window.PackSize.cartFetchInterceptorBound) {
  const nativeFetch = window.fetch;

  window.fetch = async function (...args) {
    const response =
      await nativeFetch.apply(this, args);

    try {
      const requestUrl =
        typeof args[0] === 'string' ||
        args[0] instanceof URL
          ? String(args[0])
          : args[0]?.url || '';

      if (
        response.ok &&
        window.PackSize.isCartMutationUrl(
          requestUrl
        ) &&
        !window.PackSize.isSyncingBundleGifts
      ) {
        window.PackSize.queueBundleGiftSync();
      }
    } catch (error) {
      console.error(
        'PackSize cart observer error:',
        error
      );
    }

    return response;
  };

  window.PackSize.cartFetchInterceptorBound = true;
}

/* ==========================================
   XHR CART OBSERVER
========================================== */

if (!window.PackSize.cartXHRInterceptorBound) {
  const nativeOpen =
    XMLHttpRequest.prototype.open;

  const nativeSend =
    XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (
    method,
    url,
    ...args
  ) {
    this._packSizeCartMutation =
      window.PackSize.isCartMutationUrl(
        String(url)
      );

    return nativeOpen.call(
      this,
      method,
      url,
      ...args
    );
  };

  XMLHttpRequest.prototype.send = function (...args) {
    if (this._packSizeCartMutation) {
      this.addEventListener(
        'loadend',
        () => {
          if (
            this.status >= 200 &&
            this.status < 300 &&
            !window.PackSize.isSyncingBundleGifts
          ) {
            window.PackSize.queueBundleGiftSync();
          }
        },
        { once: true }
      );
    }

    return nativeSend.apply(this, args);
  };

  window.PackSize.cartXHRInterceptorBound = true;
}

/* ==========================================
   INITIAL LOAD
========================================== */

if (document.readyState === 'loading') {
  document.addEventListener(
    'DOMContentLoaded',
    () => {
      bootPackSize(document);

      window.PackSize.queueBundleGiftSync();
    }
  );
} else {
  bootPackSize(document);

  window.PackSize.queueBundleGiftSync();
}

/* ==========================================
   QUICK ADD MODAL SUPPORT
========================================== */

if (!window.PackSize.modalObserverBound) {
  const modalObserver = new MutationObserver(
    mutations => {
      mutations.forEach(mutation => {
        mutation.addedNodes.forEach(node => {
          if (node.nodeType !== 1) {
            return;
          }

          if (
            node.querySelector?.(
              '.pack-size-cards'
            ) ||
            node.matches?.(
              '.quick-add-modal'
            )
          ) {
            bootPackSize(node);
          }
        });
      });
    }
  );

  modalObserver.observe(document.body, {
    childList: true,
    subtree: true
  });

  window.PackSize.modalObserverBound = true;
}
